<template>
  <div>
    <div id="upload-area" />
  </div>
</template>

<script>
import Uppy from '@uppy/core';
import Dashboard from '@uppy/dashboard';
import { storage } from '@/firebase';
import FirebaseStorage from '@/uppy/firebase-storage';
import 'uppy/dist/uppy.css';

export default {
  name: 'FileUpload',
  props: {
    storagePath: {
      type: String,
      required: true
    },
    resetOnComplete: {
      type: Boolean,
      required: false,
      default: true
    },
    inline: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * controls the visibility of modal dialog.
     *
     * NOTE: applicable only when **inline** is false
     */
    value: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      uppy: null
    };
  },
  watch: {
    value(newValue) {
      if (!this.inline)
        if (newValue) this.uppy.getPlugin('Dashboard').openModal();
        else {
          if (this.uppy.isModalOpen) {
            this.uppy.getPlugin('Dashboard').closeModal();
          }
        }
    }
  },
  mounted() {
    const storageRef = storage.ref().child(this.storagePath);
    this.uppy = Uppy({
      autoProceed: false,
      restrictions: {
        maxFileSize: 10000000
      }
    })
      .use(Dashboard, {
        inline: this.inline,
        target: '#upload-area',
        width: '100%',
        height: '300px',
        note: 'Up to 10 MB per file',
        showProgressDetails: true,
        closeAfterFinish: true,
        proudlyDisplayPoweredByUppy: false,
        onRequestCloseModal: () => {
          this.$emit('input', false);
          this.uppy.getPlugin('Dashboard').closeModal();
        }
      })
      .use(FirebaseStorage, { storageRef })
      .run();
    this.uppy.on('complete', result => {
      this.$emit('complete', result);
      if (this.resetOnComplete) this.uppy.reset();
      this.$emit('input', false);
    });
  }
};
</script>